import React, { ReactElement } from "react";
import { connect, FormikContextType } from "formik";
import { InkomenEnFiscusState, SociaalSyncHeightIndex } from "../infra/inkomen-en-fiscus-schema";
import { getInkomenEnFiscusTextResources } from "../infra/inkomen-en-fiscus-resources";
import { LocalDate } from "@js-joda/core";
import { LabeledBevestigingInput, LabeledNumberInput, SyncMultipleHeightProps, SyncHeight } from "adviesbox-shared";

const Aanvrager2Sociaal = ({
  formik: {
    values: { aanvrager2Sociaal }
  },
  targetRef,
  sourceRef
}: SyncMultipleHeightProps & {
  formik: FormikContextType<InkomenEnFiscusState>;
}): ReactElement => {
  const disableJareneis = !aanvrager2Sociaal.voldoetWekeneis;
  return (
    <SyncHeight
      sourceRef={sourceRef && sourceRef[SociaalSyncHeightIndex.All]}
      targetRef={targetRef && targetRef[SociaalSyncHeightIndex.All]}
    >
      <LabeledBevestigingInput
        caption="Voldoet aan wekeneis"
        name="aanvrager2Sociaal.voldoetWekeneis"
        tooltip={getInkomenEnFiscusTextResources("TooltipSociaalWekeneis")}
      />
      {aanvrager2Sociaal.voldoetWekeneis && (
        <LabeledBevestigingInput
          caption="Voldoet aan jareneis"
          name="aanvrager2Sociaal.voldoetJareneis"
          tooltip={getInkomenEnFiscusTextResources("TooltipSociaalJareneis")}
          disabled={disableJareneis}
        />
      )}
      <SyncHeight
        sourceRef={sourceRef && sourceRef[SociaalSyncHeightIndex.Arbeidsverleden]}
        targetRef={targetRef && targetRef[SociaalSyncHeightIndex.Arbeidsverleden]}
      >
        <LabeledNumberInput
          caption={`Feitelijk arbeidsverleden tot ${LocalDate.now().year()}`}
          name="aanvrager2Sociaal.feitelijkArbeidsverleden"
          tooltip={getInkomenEnFiscusTextResources("TooltipSociaalFeitelijkArbeidsverleden")}
          appendChildren={<span className="MiniLabel">Jaar</span>}
        />
      </SyncHeight>
      <LabeledNumberInput
        caption="Fictief arbeidsverleden"
        name="aanvrager2Sociaal.fictiefArbeidsverleden"
        readonly={true}
        appendChildren={<span className="MiniLabel">Jaar</span>}
      />
    </SyncHeight>
  );
};

export default connect<SyncMultipleHeightProps, InkomenEnFiscusState>(Aanvrager2Sociaal);
